import Public from "routes/root/public";

export default Public;
